import { tsvParseRows } from 'd3-dsv';

import { QuestionFormData, QuestionType } from './types';

export class ETITextParsingError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ETITextParsingError';
  }
}

const EXPECTED_TSV_COLUMNS = 5;

export const textToQuestions = (text: string): QuestionFormData[] => {
  const isExcelFormat = text.includes('\t');

  if (isExcelFormat) {
    const rows = tsvParseRows(text, (row: string[] | null) => {
      if (!row) return null;
      if (row.every((cell: string) => !cell.trim())) return null;
      return row;
    });

    return rows
      .map((row: string[]) => {
        if (row.length !== EXPECTED_TSV_COLUMNS) {
          throw new ETITextParsingError(
            'The copied data must have exactly 5 columns.',
          );
        }

        const [
          typeCell = '',
          sectionCell = '',
          questionCell = '',
          answerChoicesCell = '',
          filterCell = '',
        ] = row.slice(0, EXPECTED_TSV_COLUMNS).map(cell => cell.trim());

        const normalizedType = typeCell
          .toLowerCase()
          .replace('-', '_')
          .replace('optionaltext', 'optional_text') as QuestionType;

        const question = questionCell.replace(/^"([\s\S]*)"$/, '$1');

        let options: string[] | undefined = undefined;
        if (['radio', 'checkbox'].includes(normalizedType)) {
          try {
            if (answerChoicesCell) {
              const parsed = JSON.parse(answerChoicesCell);
              if (Array.isArray(parsed)) {
                options = parsed.map(v => String(v));
              }
            }
          } catch (_) {
            // ignore parse errors; options stay undefined and will be validated client-side
          }
        }

        let filter: QuestionFormData['filter'] = undefined;
        if (filterCell) {
          try {
            const parsedFilter = JSON.parse(filterCell);
            if (parsedFilter && typeof parsedFilter === 'object') {
              filter = parsedFilter as any;
            }
          } catch (_) {
            // ignore parse errors; filter remains undefined
          }
        }

        const mappedType: QuestionType = (
          (normalizedType as any) === 'upload'
            ? 'attachment'
            : (normalizedType as any)
        ) as QuestionType;

        return {
          questionType: mappedType,
          section: sectionCell,
          question,
          options,
          filter,
          optionsRaw: answerChoicesCell || '',
          filterRaw: filterCell || '',
        } as QuestionFormData;
      })
      .filter(
        ({ questionType, section, question }) =>
          section && question && !!questionType,
      );
  }

  return [];
};
